import {
  CreateContextProvider,
  SimpleForm,
  TextInput,
  useCreateController,
} from "react-admin";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { RichTextInput } from "ra-input-rich-text";

export const MailTemplateCreate = (props: any) => {
  const controller: any = useCreateController({
    resource: "mail-templates/crud",
  });

  return (
    <CreateContextProvider value={controller}>
      <SimpleForm>
        <PageTopBreadcrumb
          title="Template de E-mail"
          firstPath="/#/mail-templates/crud"
          secondTitle="Novo"
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Criar" />
          <CardContent>
            <Grid container spacing={0.5}>
              <Grid item xs={12} lg={12}>
                <TextInput
                  source="name"
                  fullWidth
                  helperText={false}
                  label="Nome"
                />
                <TextInput
                  source="trigger"
                  label="Gatilho"
                  fullWidth
                  helperText={false}
                />
                <TextInput
                  source="subject"
                  label="Assunto"
                  fullWidth
                  helperText={false}
                />
                <RichTextInput
                  source="body"
                  label="Corpo"
                  fullWidth
                  helperText={false}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </CreateContextProvider>
  );
};
